export const LABEL_WIDTH = 140;
export const LABEL_HEIGHT = 40;
export const LABEL_SPACING = 8;
export const CREATE_PERSONA_ID = 'create_persona';
